import React, { Component } from 'react'
import axios from "axios"

export class NoDepartmentModal extends Component {
    state = {
        departmentLists: [],
        selectedDepartment: "",
        department: [
          "",
        ]
    }

    componentDidMount(){
        axios({
            method: 'GET',
            url: `${process.env.REACT_APP_API_KEY}/api/departments`,
            headers: {
              'Api-Key':
                '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
              Authorization: `Bearer ${localStorage.token}`
            }
          })
            .then(response => {
              console.log(response)
              this.setState({
                departmentLists: response.data.data
              })
              // console.log(this.state.departmentLists)
          })
          .catch(error => {
              // console.log(error.response)   
            })
    }

    handleRequestForDepartment = (e) => {
        // e.preventDefault()
        console.log(this.state.selectedDepartment)
        axios({
            method: 'PUT',
            url: `${process.env.REACT_APP_API_KEY}/api/userInfo/departmentRequest`,
            data: {
              departments: this.state.department
            },
            headers: {
              'Api-Key':
                '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
              Authorization: `Bearer ${localStorage.token}`
            }
          })
            .then(response => {
                console.log(response)
                // window.location.reload();
          })
          .catch(error => {
            
            })
    }

    
    handleSelectDepartment = (e) => {
      console.log(e.target.id)
      let deptCopy = this.state.department
      deptCopy[e.target.id] = e.target.value
      console.log(deptCopy[e.target.id])
      this.setState({
          selectedDepartment: deptCopy
      })
  }


    handleAddDptInput = () => {
      let deptCopy = this.state.department
      deptCopy.push("")
      this.setState({
        department: deptCopy
      })
    }

    render() {  

        let chooseDepartment = ""

        if(this.props.selectDepartment){
          
            chooseDepartment = <div className="modalContent">
            <h4 className="returnHeader">Select Your Department</h4>
                 <form action="">
                     <div className="returnLabel">
                         <small id="returnValidation"></small>
                     </div>
                     {this.state.department.map((department, index) => 
                       <input name="department"
                        type="text"
                        id={index}
                        list="departmentList"
                        onChange={this.handleSelectDepartment}
                        className="selectDepartmentInput"
                      />
                      
                      )}
                   
                        <datalist id="departmentList">
                        {this.state.departmentLists.map(data => 
                            <option value={data}/>
                        )}
                        </datalist>
                        {/* <div className="addDptBtnContainer">
                          <button type="button" onClick={this.handleAddDptInput} className="addDptBtn">&#x2B;</button>
                        </div> */}
                            
                     <div className="modalBtnContainer">
                             <button className="cancelModalBtn" onClick={this.props.closeReturnModal}>CANCEL</button>
                             <button className="returnBtnDept" onClick={this.handleRequestForDepartment}>CONFIRM</button>
                     </div>
                         </form>   
             </div>  
        }

        if(this.props.waitForApproval){
            chooseDepartment = <div className="modalContent">
            <h4 className="returnHeader">Message:</h4>
            <div id="approveMessage">
                     <h5>
                         You are still not allowed to request.<br/>
                         Please wait for the confirmation of Department Head.
                     </h5>
                 </div>
                 <div className="modalBtnContainer">
                             <button type="button" className="cancelModalBtn" onClick={this.props.closeReturnModal}>OK</button>
                             {/* <a  href={this.props.crfLink} className="returnBtnDept" onClick={this.props.handleTransmitted}>CONFIRM</a> */}
              
                     </div>
             </div>  
        }
        
        

        // if(this.props.editCrfDetails === true){
        //     approveContent =<div className="modalContent">
        //     <h4 className="returnHeader">edit Details Request</h4>
        //      </div>  
        // }


        return (
            <div id="modalBody" className="modalBody">
            <div className="modalContainer" >
               <div className="modalbg" onClick={this.props.closeReturnModal}></div>
                {chooseDepartment}

            </div>
     
      </div>
        )
    }
}

export default NoDepartmentModal
